import { Injectable } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CCDL_VALIDATOR_CONSTANTS } from '@cpm-pr1618001/ng-design-lib';
import { ContactUsDetails } from './store/state/landing-page.state';

@Injectable({
  providedIn: 'root',
})
export class LandingPagePresenter {
  private contactFormGroup!: FormGroup;
  constructor(private fb: FormBuilder) {}

  initializeContactForm(): FormGroup {
    this.contactFormGroup = this.fb.group({
      firstName: this.fb.control(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.pattern(CCDL_VALIDATOR_CONSTANTS.NAME_PATTERN),
      ]),
      lastName: this.fb.control(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.pattern(CCDL_VALIDATOR_CONSTANTS.NAME_PATTERN),
      ]),
      emailAddress: this.fb.control(null, [
        Validators.required,
        Validators.pattern(CCDL_VALIDATOR_CONSTANTS.EMAIL_PATTERN),
      ]),
      countryCodeIso2: this.fb.control(null, [Validators.required]),
      helpTextField: this.fb.control(null, [
        Validators.required,
        Validators.pattern(CCDL_VALIDATOR_CONSTANTS.TEXTAREA_CONTENT_PATTERN),
      ]),
      website: this.fb.control(''),
    });
    return this.contactFormGroup;
  }

  getContactFormGroup(): FormGroup {
    return this.contactFormGroup;
  }

  getControl(controlName: string): FormControl {
    return this.contactFormGroup.get(controlName) as FormControl;
  }

  getContactFormPayload(): ContactUsDetails {
    const form = this.contactFormGroup.value;
    return {
      firstName: form.firstName,
      lastName: form.lastName,
      emailAddress: form.emailAddress,
      helpTextField: form.helpTextField,
      website: form.website || '',
      countryCodeIso2: form.countryCodeIso2,
    };
  }

  resetContactForm(): void {
    this.contactFormGroup?.reset();
  }
}
